import { render, staticRenderFns } from "./AmAvatarDataUrl.vue?vue&type=template&id=b58b190a&scoped=true&"
import script from "./AmAvatarDataUrl.vue?vue&type=script&lang=js&"
export * from "./AmAvatarDataUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58b190a",
  null
  
)

export default component.exports